import api from '../api/Interceptors';

const uploadImageList = (url, body) => api.post(url, body);

export default {
  uploadImageList,
};
